"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginButton = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var link_1 = require("../../ui/link");
function LoginButton() {
    var navigate = (0, react_router_dom_1.useNavigate)();
    function goToLogin() {
        navigate("/login");
    }
    return (react_1.default.createElement("div", { onClick: goToLogin },
        react_1.default.createElement(link_1.LinkButton, null, "INICIAR SESION")));
}
exports.LoginButton = LoginButton;
